import React, { Component } from 'react';
import { Avatar, Layout, Menu, Spin } from 'antd';
import {
  LoadingOutlined,
  DashboardOutlined,
  AppstoreOutlined,
  ReconciliationOutlined,
  AuditOutlined,
  ShareAltOutlined,
  UsergroupAddOutlined,
  SettingOutlined,
  IdcardOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  MobileOutlined,
  PushpinOutlined,
  FileTextOutlined,
  WifiOutlined,
  ApartmentOutlined,
  CarOutlined,
  FileDoneOutlined,
  SortAscendingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { history } from '../../utils/history';
import CustomRouter from '../../components/Routing/CustomRouter.jsx';
import { checkUserLogin, login, logout } from '../../actions/AuthActions';
import './BasicLayout.less';
import { getCurrentUserAction } from '../../actions/UserActions';
import UserContext from './UserContext';
import checkPermission from '../../components/Authorization/Util';
import checkEnabledFeatures from '../../components/Authorization/Feature';
import LoginPage from '../login/LoginPage';
import FbqPolicyPage from '../policy/fbq';
import ExploremaltaPolicyPage from '../policy/exploremalta';
import { getUsernameAvatar } from '../../utils/userAvatars';
import NotFound from '../../components/NotFound';

const { Header, Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;

const getAvatar = currentUser => {
  if (!currentUser) return '';
  if (!currentUser.avatarUrl)
    return getUsernameAvatar(currentUser.username, 'normal');
  return <Avatar src={currentUser ? currentUser.avatarUrl : ''}/>;
};

class BasicLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      smallIcon: false,
    };
  }

  async componentDidMount() {
    const { checkUserLogin: checkUserLogin1 } = this.props;
    await checkUserLogin1();
    const { getCurrentUserAction: getCurrentUserAction1 } = this.props;
    await getCurrentUserAction1();
  }

  handleOnCollapse = () => {
    this.setState(
      {
        collapsed: !this.state.collapsed,
      },
      () => {
        setTimeout(
          () =>
            this.setState({
              smallIcon: !this.state.smallIcon,
            }),
          150,
        );
      },
    );
  };

  handleSiderMenuClick = action => {
    if (action.key === 'logout') {
      this.handleLogout();
    } else {
      history.push('/' + action.key);
    }
  };

  retrieveSelectedKeyFromPath = () => {
    const { location } = this.props;
    const pathName = location.pathname.replace(/\//g, '');
    return [pathName];
  };

  handleSettingMenuClick = e => {
    if (e.key === 'setting:1') {
      history.push('/profile');
    } else if (e.key === 'setting:2') {
      const { props } = this;
      props.logout();
    }
  };

  handleLogout = () => {
    const { logout: logout1 } = this.props;
    logout1();
  };

  render() {
    const pathName = window.location.pathname.replace(/\//g, '');
    const { collapsed } = this.state;
    const { loggingIn, loggedIn } = this.props;

    const tenant = window.location.hostname.split('.')[0];
    if (pathName === 'policy') {
      switch (tenant) {
        case 'fbq':
          return <FbqPolicyPage/>;
        case 'exploremalta':
          return <ExploremaltaPolicyPage/>;
        default:
          return <NotFound/>;
      }
    }

    if (!loggedIn && loggingIn === false) {
      return <LoginPage/>;
    } if (loggingIn === true) {
      return (
        <div
          style={{
            height: '100vh',
            width: '100%',
            backgroundColor: 'white',
            textAlign: 'center',
            position: 'absolute',
          }}
        >
          <Spin
            style={{ top: '50%', position: 'absolute' }}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin/>}
          />
        </div>
      );
    } else {
      const { currentUser } = this.props;
      const { smallIcon } = this.state;
      return (
        <UserContext.Provider
          value={currentUser}
        >
          <Layout style={{ minHeight: '100vh' }}>
            <Sider
              breakpoint="lg"
              collapsedWidth="80"
              onCollapse={this.handleOnCollapse}
              collapsed={collapsed}
              width="256"
              theme="light"
            >
              <a
                onClick={() => {
                  history.push('/');
                }}
              >
                <div
                  className={
                    collapsed && smallIcon ? 'menu-logo-collapsed' : 'menu-logo'
                  }
                />
              </a>
              <Menu
                mode="inline"
                defaultSelectedKeys={this.retrieveSelectedKeyFromPath()}
                onClick={this.handleSiderMenuClick}
              >
                {checkEnabledFeatures(currentUser, 'Item-Cataloging') && (
                  <Menu.Item key="dashboard">
                    <DashboardOutlined/>
                    <span className="nav-text">Dashboard</span>
                  </Menu.Item>
                )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'item', 'read') && (
                    <SubMenu
                      key="object"
                      title={
                        <span>
                        <AppstoreOutlined/>
                        <span>Objects</span>
                      </span>
                      }
                    >
                      <Menu.Item key="objects">Show Objects</Menu.Item>
                      {checkPermission(currentUser, 'item', 'write') && (
                        <Menu.Item key="add-object">Add Object</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'condition', 'read') && (
                    <SubMenu
                      key="condition"
                      title={
                        <span>
                        <ReconciliationOutlined/>
                        <span>Conditions</span>
                      </span>
                      }
                    >
                      <Menu.Item key="conditions">Show Conditions</Menu.Item>
                      {checkPermission(currentUser, 'condition', 'write') && (
                        <Menu.Item key="add-condition">Add Condition</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'curatorialForm', 'read') && (
                    <SubMenu
                      key="curatorial-form"
                      title={
                        <span>
                        <ApartmentOutlined/>
                        <span>Curatorial Form</span>
                      </span>
                      }
                    >
                      <Menu.Item key="curatorial-forms">Show Curatorial Forms</Menu.Item>
                      {checkPermission(currentUser, 'curatorialForm', 'write') && (
                        <Menu.Item key="add-curatorial-form">Add Curatorial Form</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'technicalForm', 'read') && (
                    <SubMenu
                      key="technical-form"
                      title={
                        <span>
                        <CarOutlined/>
                        <span>Technical Form</span>
                      </span>
                      }
                    >
                      <Menu.Item key="technical-forms">Show Technical Forms</Menu.Item>
                      {checkPermission(currentUser, 'technicalForm', 'write') && (
                        <Menu.Item key="add-technical-form">Add Technical Form</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'movement', 'read') && (
                    <SubMenu
                      key="movement"
                      title={
                        <span>
                        <ShareAltOutlined/>
                        <span>Movements</span>
                      </span>
                      }
                    >
                      <Menu.Item key="movements">Show Movements</Menu.Item>
                      {checkPermission(currentUser, 'movement', 'write') && (
                        <Menu.Item key="add-movement">Add Movement</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'treatment', 'read') && (
                    <SubMenu
                      key="treatment"
                      title={
                        <span>
                        <AuditOutlined/>
                        <span>Treatments</span>
                      </span>
                      }
                    >
                      <Menu.Item key="treatments">Show Treatments</Menu.Item>
                      {checkPermission(currentUser, 'treatment', 'write') && (
                        <Menu.Item key="add-treatment">Add Treatment</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'Item-Cataloging') &&
                  checkPermission(currentUser, 'insurance', 'read') && (
                    <SubMenu
                      key="insurance"
                      title={
                        <span>
                        <FileDoneOutlined/>
                        <span>Insurances</span>
                      </span>
                      }
                    >
                      <Menu.Item key="insurances">Show Insurances</Menu.Item>
                      {checkPermission(currentUser, 'insurance', 'write') && (
                        <Menu.Item key="add-insurance">Add Insurance</Menu.Item>
                      )}
                    </SubMenu>
                  )}

                {checkEnabledFeatures(currentUser, 'App-Cms') &&
                  checkPermission(currentUser, 'appcms', 'read') && (
                    <SubMenu
                      key="appCms"
                      title={
                        <span>
                        <MobileOutlined/>
                        <span>App CMS</span>
                      </span>
                      }
                    >
                      <SubMenu
                        key="pointsOfInterest"
                        title={
                          <span>
                          <PushpinOutlined/>
                          <span>POI</span>
                        </span>
                        }
                      >
                        <Menu.Item key="pois">Show POIs</Menu.Item>
                        <Menu.Item key="add-poi">Add POI</Menu.Item>
                        <Menu.Item key="poi-groups">POI Groups</Menu.Item>
                        <Menu.Item key="add-poi-group">Add POI Group</Menu.Item>
                      </SubMenu>
                      <SubMenu
                        key="beacon"
                        title={
                          <span>
                          <WifiOutlined/>
                          <span>Beacon</span>
                        </span>
                        }
                      >
                        <Menu.Item key="beacons">Show Beacons</Menu.Item>
                        <Menu.Item key="beacon-scans">Beacon Scans</Menu.Item>
                      </SubMenu>
                      <SubMenu
                        key="new"
                        title={
                          <span>
                          <FileTextOutlined/>
                          <span>News</span>
                        </span>
                        }
                      >
                        <Menu.Item key="news">Show News</Menu.Item>
                        <Menu.Item key="add-news">Add News</Menu.Item>
                      </SubMenu>
                      <Menu.Item icon={<SettingOutlined/>} key="app-settings">App Settings</Menu.Item>
                      <Menu.Item icon={<SortAscendingOutlined />} key="languages">Languages</Menu.Item>
                    </SubMenu>
                  )}

                {checkPermission(currentUser, 'user', 'read') && (
                  <SubMenu
                    key="userManagement"
                    title={
                      <span>
                      <UsergroupAddOutlined/>
                      <span>User Management</span>
                    </span>
                    }
                  >
                    <Menu.Item key="user-list">User List</Menu.Item>
                    {checkPermission(currentUser, 'user', 'write') && (
                      <Menu.Item key="add-user">Add User</Menu.Item>
                    )}
                    <Menu.Item key="user-groups">User Groups</Menu.Item>
                    {checkPermission(currentUser, 'user', 'write') && (
                      <Menu.Item key="activity-log">Activity Log</Menu.Item>
                    )}
                    {checkPermission(currentUser, 'user', 'write') && (
                      <Menu.Item key="permissions">Permissions</Menu.Item>
                    )}
                  </SubMenu>
                )}

                {checkPermission(currentUser, 'setting', 'read') && (
                  <Menu.Item key="dropdowns">
                    <SettingOutlined/>
                    <span className="nav-text">Dropdowns</span>
                  </Menu.Item>
                )}
                <Menu.Item key="profile">
                  <IdcardOutlined/>
                  <span className="nav-text">Profile</span>
                </Menu.Item>
                <Menu.Item key="logout">
                  <LogoutOutlined/>
                  <span className="nav-text">Logout</span>
                </Menu.Item>
              </Menu>
            </Sider>
            <Layout>
              <Header
                className="header"
                style={{ background: '#fff', padding: 0 }}
              >
                <div
                  style={{
                    float: 'left',
                    width: '100%',
                    alignSelf: 'center',
                    display: 'flex',
                  }}
                >
                  {window.innerWidth > 992 &&
                    (collapsed ? (
                      <MenuUnfoldOutlined
                        style={{
                          marginLeft: 16,
                          marginRight: 16,
                          alignSelf: 'center',
                        }}
                        className="trigger"
                        onClick={() => this.handleOnCollapse()}
                      />
                    ) : (
                      <MenuFoldOutlined
                        style={{
                          marginLeft: 16,
                          marginRight: 16,
                          alignSelf: 'center',
                        }}
                        className="trigger"
                        onClick={() => this.handleOnCollapse()}
                      />
                    ))}
                </div>
                <Menu
                  onClick={this.handleSettingMenuClick}
                  mode="horizontal"
                  className="menu"
                >
                  <SubMenu key="extra" title={getAvatar(currentUser)}>
                    <Menu.Item key="setting:1">
                    <span>
                      <UserOutlined/>
                      Profile
                    </span>
                    </Menu.Item>
                    <Menu.Item key="setting:2">
                    <span>
                      <LogoutOutlined onClick={() => this.handleLogout()}/>
                      Logout
                    </span>
                    </Menu.Item>
                  </SubMenu>
                </Menu>
              </Header>
              <Content>
                <CustomRouter/>
              </Content>
              <Footer style={{ textAlign: 'center' }}>
                Museum Sense © {new Date().getFullYear()}
              </Footer>
            </Layout>
          </Layout>
        </UserContext.Provider>
      );
    }
  }
}

BasicLayout.propTypes = {
  loggingIn: PropTypes.bool,
  loggedIn: PropTypes.string,
  checkUserLogin: PropTypes.func,
  logout: PropTypes.func,
  location: PropTypes.object,
  currentUser: PropTypes.object,
  getCurrentUserAction: PropTypes.func,
};

function mapStateToProps({ auth, userReducer }) {
  const { loggedIn, loggingIn } = auth;
  const { currentUser } = userReducer;
  return { loggedIn, loggingIn, currentUser };
}

export default connect(mapStateToProps, {
  checkUserLogin,
  login,
  logout,
  getCurrentUserAction,
})(BasicLayout);
